import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=0ae61506&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"
import style0 from "./Publish.vue?vue&type=style&index=0&id=0ae61506&prod&lang=css"
import style1 from "./Publish.vue?vue&type=style&index=1&id=0ae61506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae61506",
  null
  
)

export default component.exports